// Guards a redirect target that comes from the request (e.g. a ReturnUrl query parameter). Returns the url only when
// it stays on the current origin - a relative url, or an absolute http(s) url to the same origin. Anything else
// (another origin, a protocol-relative "//host" url, a "javascript:" url, a malformed url) returns the fallback
// instead, so an attacker-supplied ReturnUrl cannot redirect the browser off-site or run script after login
// (open redirect / XSS).
define('lq/safeRedirectUrl',[], function () {
    'use strict';

    return function safeRedirectUrl(url, fallback) {
        if (!url) {
            return fallback;
        }

        try {
            var resolved = new URL(url, window.location.href);
            var isHttp = resolved.protocol === 'http:' || resolved.protocol === 'https:';
            if (isHttp && resolved.origin === window.location.origin) {
                return url;
            }
        } catch (e) {
            // not a valid url
        }

        return fallback;
    };
});

